import {
  ReportAction as Action,
  ReportActionTypes as ActionTypes,
  Contractor,
  Property,
  ReportFormat,
  ReportItem,
  SelectReportItem,
} from './types';
import { DisplayParams } from '@ducks/common/types';

/**
 * @summary 初期化処理
 * @returns {Action}
 */
export const init = (): Action => ({ type: ActionTypes.INIT });

/**
 * @summary リフレッシュ処理
 * @returns {Action}
 */
export const refresh = (): Action => ({ type: ActionTypes.REFRESH });

/**
 * @summary Loading状態を保持
 * @param {boolean} isLoading
 * @returns {Action}
 */
export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
});

/**
 * @summary 月報フォーマットリストのLoading状態を保持
 * @param {boolean} isReportFormatListLoading
 * @returns {Action}
 */
export const setIsReportFormatListLoading = (isReportFormatListLoading: boolean): Action => ({
  type: ActionTypes.REPORT_FORMAT_LIST_LOADING,
  payload: isReportFormatListLoading,
});

/**
 * @summary 送信処理中かを保持
 * @param {boolean} isSubmitting
 * @returns {Action}
 */
export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting,
});

/**
 * @summary 月報の項目定義リストを保持
 * @param {Property[]} propertyList
 * @returns {Action}
 */
export const setPropertyList = (propertyList: Property[]): Action => ({
  type: ActionTypes.SET_PROPERTY_LIST,
  payload: propertyList,
});

/**
 * @summary 建物リストのページャ情報を保持
 * @param {DisplayParams} propertyListDisplayParams
 * @returns {Action}
 */
export const setPropertyListDisplayParams = (propertyListDisplayParams: DisplayParams): Action => ({
  type: ActionTypes.SET_PROPERTY_LIST_DISPLAY_PARAMS,
  payload: propertyListDisplayParams,
});

/**
 * @summary 月報の項目定義リストを保持
 * @param {Contractor[]} contractorList
 * @returns {Action}
 */
export const setContractorList = (contractorList: Contractor[]): Action => ({
  type: ActionTypes.SET_CONTRACTOR_LIST,
  payload: contractorList,
});

/**
 * @summary 契約先リストのページャ情報を保持
 * @param {DisplayParams} contractorListDisplayParams
 * @returns {Action}
 */
export const setContractorListDisplayParams = (
  contractorListDisplayParams: DisplayParams,
): Action => ({
  type: ActionTypes.SET_CONTRACTOR_LIST_DISPLAY_PARAMS,
  payload: contractorListDisplayParams,
});

/**
 * @summary 月報出力対象リストの建物/契約先名
 * @param {string} reportTargetName
 * @returns {Action}
 */
export const setReportTargetName = (reportTargetName: string): Action => ({
  type: ActionTypes.SET_REPORT_TARGET_NAME,
  payload: reportTargetName,
});

/**
 * @summary 月報の出力対象リストを保持
 * @param {ReportItem[]} reportItemList
 * @returns {Action}
 */
export const setReportItemList = (reportItemList: ReportItem[]): Action => ({
  type: ActionTypes.SET_REPORT_ITEM_LIST,
  payload: reportItemList,
});

/**
 * @summary 月報の出力対象全リストを保持
 * @param {ReportItem[]} reportItemListAll
 * @returns {Action}
 */
export const setReportItemListAll = (reportItemListAll: ReportItem[]): Action => ({
  type: ActionTypes.SET_REPORT_ITEM_LIST_ALL,
  payload: reportItemListAll,
});

/**
 * @summary 月報出力対象リストのページャ情報を保持
 * @param {DisplayParams} reportItemDisplayParams
 * @returns {Action}
 */
export const setReportItemDisplayParams = (reportItemDisplayParams: DisplayParams): Action => ({
  type: ActionTypes.SET_REPORT_ITEM_DISPLAY_PARAMS,
  payload: reportItemDisplayParams,
});

/**
 * @summary 月報フォーマットリストを保持
 * @param {ReportFormat[]} reportFormatList
 * @returns {Action}
 */
export const setReportFormatList = (reportFormatList: ReportFormat[]): Action => ({
  type: ActionTypes.SET_REPORT_FORMAT_LIST,
  payload: reportFormatList,
});

/**
 * @summary 月報フォーマットリストのページャ情報を保持
 * @param {DisplayParams} reportFormatDisplayParams
 * @returns {Action}
 */
export const setReportFormatDisplayParams = (reportFormatDisplayParams: DisplayParams): Action => ({
  type: ActionTypes.SET_REPORT_FORMAT_DISPLAY_PARAMS,
  payload: reportFormatDisplayParams,
});

/**
 * @summary 選択中の月報フォーマットを保持
 * @param {ReportFormat | null} selectedReportFormat
 * @returns {Action}
 */
export const setSelectedReportFormat = (selectedReportFormat: ReportFormat | null): Action => ({
  type: ActionTypes.SET_SELECTED_REPORT_FORMAT,
  payload: selectedReportFormat,
});

/**
 * @summary 選択された月報出力対象リスト
 * @param {SelectReportItem[]} selectReportItemList
 * @returns {Action}
 */
export const setSelectReportItemList = (selectReportItemList: SelectReportItem[]): Action => ({
  type: ActionTypes.SET_SELECT_REPORT_ITEM_LIST,
  payload: selectReportItemList,
});
